import { Component } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { FiniteStateMachineListService } from 'src/app/core/services/list-services/finite-state-machine-list.service';
import { Observable } from 'rxjs';
import { FiniteStateMachineModel } from 'src/app/core/models/finiteStateMachines/finite-state-machine.model';
import { FiniteStateMachineSortBy } from 'src/app/core/enums/sort-by-options/finite-state-machine-sort-enum';
import { IntervalEnum } from 'src/app/core/enums/intervals-enum';
import Swal from 'sweetalert2';
import { Roles } from 'src/app/core/security/roles';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { FsmApiService } from 'src/app/core/services/fsmApi.service';
import { FiniteStateMachinesListConfig } from './configs/finite-state-machine-list.config';

@Component({
  selector: 'app-finite-state-machine-list',
  templateUrl: './finite-state-machine-list.component.html',
  styleUrls: ['./finite-state-machine-list.component.scss']
})
export class FiniteStateMachineListComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  fsmIsEnabledAvailableOptions = [
    { value: undefined, text: "Select Status" },
    { value: true, text: $localize`:@@FSM_Status_Enabled:Enabled` },
    { value: false, text: $localize`:@@FSM_Status_Disabled:Disabled` }
  ]

  fsmIsEnabledSelectedOption: boolean | undefined;

  protected override searchPlaceHolderText: string = $localize`:@@:Search for Finite State Machines by name`;

  // Table data
  override listItemsObservable!: Observable<FiniteStateMachineModel[]>;

  sortBy: FiniteStateMachineSortBy = FiniteStateMachineSortBy.None;
  enumFiniteStateMachineSortBy = FiniteStateMachineSortBy;

  securityPermissionFSMCreate: boolean = this.authMyFileService.isInRole(Roles.admin);
  securityPermissionFSMDelete: boolean = this.authMyFileService.isInRole(Roles.admin);
  securityPermissionFSMUpdate: boolean = this.authMyFileService.isInRole(Roles.admin);

  constructor(
    protected fsmApiService: FsmApiService,
    protected fmsListService: FiniteStateMachineListService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override openModalService: OpenModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    this.listItemsObservable = this.fmsListService.resultItems$;
    this.total = this.fmsListService.total$;
    this.isLoading = this.fmsListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);

    this.tableConfig = new FiniteStateMachinesListConfig();

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.fmsListService.totalRecords;
      this.serviceData.pageSize = this.fmsListService.pageSize;
      this.serviceData.pageIndex = this.fmsListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);

  }

  ngOnDestroy() {
    this.clearSearch(this.fmsListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  //** new simpler sort function for futher lists with new layout component */
  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.fmsListService, '', '');
    } else {
      this.serviceSort(this.fmsListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.openFiniteStateMachineModal(rowAction.model, this.fmsListService);
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.deleteListItem(rowAction.model.id)
        }
        break;
      case ActionIdEnum.EnableDisable:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.changeMachineStatus(rowAction.model);
        break;

    }

  }
  buttonActionSelected(buttonAction: any): void {
    if (buttonAction.buttonId === undefined) {
      buttonAction = { buttonId: buttonAction  }
    }
    switch (buttonAction.buttonId) {
      case ButtonIdEnum.CreateNew:
        this.openModalNew();
        break;
      case ButtonIdEnum.Delete:
        this.deleteMultipleListItems();
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel) {
    switch (filterSelected.label) {
      case 'status':
        this.fmsListService.isEnabled = filterSelected.selectedOption;
        break;
    }
  }


  changeMachineStatus(machine: FiniteStateMachineModel) {
    if (machine.isEnabled) {
      Swal.fire({
        title: $localize`:@@:Disable ${machine.name}`,
        text: $localize`:@@:Are you sure you want to disable this machine?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Yes`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          machine.isEnabled = false;
          this.updateFSM(machine);
        }
      });
    } else {
      Swal.fire({
        title: $localize`:@@:Enable ${machine.name}`,
        text: $localize`:@@:Are you sure you want to enable this machine?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Yes`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          machine.isEnabled = true;
          this.updateFSM(machine);
        }
      });
    }

  }

  updateFSM(machine: FiniteStateMachineModel) {
    this.submitted = true;
    this.fsmApiService.updateFiniteStateMachines(machine).subscribe((result: boolean | undefined) => {
      if (result) {
        this.fmsListService.sortColumn = this.fmsListService.sortColumn;
        this.toasterNotificationService.showSuccess($localize`:@@: Finite State Machine has been updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
      }
      this.submitted = false;
    })
  }


  fsmIsEnabledFilter() {
    switch (this.fsmIsEnabledSelectedOption) {
      case true:
        this.fmsListService.isEnabled = true;
        break;
      case false:
        this.fmsListService.isEnabled = false;
        break;
      default:
        this.fmsListService.isEnabled = undefined;
        break;
    }
  }

  openModalNew() {
    this.openModalService.newFiniteStateMachineModal(this.fmsListService);
  }

  deleteListItem(modelId: string | undefined, waitToReloadList?: boolean) {
    if (modelId) {
      this.submitted = true;
      this.fsmApiService.deleteFiniteStateMachines(modelId).subscribe(
        (result: boolean | undefined) => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@:Machine Deleted`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          if (waitToReloadList !== true) {
            this.sortByPassedSort(new EmitSortModel(SortByTypeEnum.None, undefined)); //refreshes list
            this.submitted = false;
          }
        }
      )
    }
  }

  deleteMultipleListItems() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result: any;
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 0) {
      Swal.fire({
        title: $localize`:@@:Delete Finite State Machines`,
        text: $localize`:@@:Are you sure you want to delete these Machines?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          for (var i = 0; i < checkedVal.length; i++) {
            if (i != checkedVal.length - 1) {
              this.deleteListItem(checkedVal[i], true);
            } else {
              this.deleteListItem(checkedVal[i])
            }
          }
          this.fmsListService.startIndex = this.fmsListService.startIndex;
        }
      });
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Finite State Machine to Delete',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
    this.checkedValGet = checkedVal;
  }

}
